export default __webpack_public_path__ + "static/media/hello-beautiful-mobile@2X.4fb6cf6d.png";